import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import { deviceTypes } from "../../shared/enums/deviceTypes";
import Layout from "../layout/Layout";
import LogoAndImagePage from "../pages/logoAndImage/LogoAndImagePage";
import RolePermissionsPage from "../pages/rolePermissions/RolePermissionsPage";
import UsefulToolsPage from "../pages/toolsPage/UsefulToolsPage";
import SystemMessagesPage from "../pages/systemMessages/SystemMessagesPage";
import ManagerMobilePage from "../pages/managerMobilePage/ManagerMobilePage";
import pathRouts from "../../shared/enums/pathRoute";

const App = () => {

    const { isManager } = useSelector((state) => state.auth);
    const { deviceType } = useSelector((state) => state.responsive);

    if (deviceType === deviceTypes.mobile)
        return <ManagerMobilePage />;

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route
                    path={pathRouts.ROLEHOLDERS}
                    element={isManager ? <RolePermissionsPage /> : <Navigate to={pathRouts.LOGOANDIMAGE} replace />}
                />
                <Route path={pathRouts.LOGOANDIMAGE} element={<LogoAndImagePage />} />
                <Route path={pathRouts.TOOLSPAGE} element={<UsefulToolsPage />} />
                <Route path={pathRouts.SYSTEMMESSAGES} element={<SystemMessagesPage />} />
                <Route path="*" element={<Navigate to={pathRouts.LOGOANDIMAGE} replace />} />
            </Route>
        </Routes>
    );
};

export default App;
